import { getEnvironmentConfig } from '@/shared/config/environments';

const envConfig = getEnvironmentConfig(import.meta.env.MODE);

export const PROMETHEUS_CONFIG = {
  NAMESPACE: import.meta.env.VITE_PROMETHEUS_NAMESPACE || envConfig.prometheus.namespace,
} as const;

export const isPrometheusConfigured = (): boolean => {
  return Boolean(PROMETHEUS_CONFIG.NAMESPACE);
};

export const getPrometheusConfigError = (): string => {
  if (!PROMETHEUS_CONFIG.NAMESPACE) {
    console.warn('========================================');
    console.warn('🔧 Prometheus Config');
    console.warn('========================================');
    console.warn('PROMETHEUS_CONFIG.NAMESPACE:', PROMETHEUS_CONFIG.NAMESPACE);
    console.warn('========================================');

    return '시스템 모니터링 기능이 준비되지 않았습니다';
  }
  return '';
};
